import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as listsActions from '../../store/lists/actions';
import * as adsActions from '../../store/ads/actions';
import * as reducers from '../../store/reducers';

import ContentCollections from 'Containers/ContentCollections';
import Hero from 'Containers/Hero';
import RampUnit from '../../utils/Playwire/RampUnit';
import Loading from 'Components/Loading';
import DocumentHeadFields from 'Components/DocumentHeadFields';
import VideoSiderailPlayer from 'Components/VideoSiderailPlayer';
import ErrorPage from 'Screens/ErrorPage';
import AdditionalMaterials from 'Components/AdditionalMaterials';

import { withLocationWrapper } from '../../utils/HOC_LocationWrapper';

// import Hero from 'Containers/Hero';

import {
  MONSTER_ME_LANDING_HERO,
  // HARRY_MOON_SERIES_HERO,
  MONSTER_ME_MEDIA_TYPE,
  PARTNERSHIPS_AND_RESOURCES,
} from './constants';

import { ACTIVE_AD_CAMPAIGNS } from '../../constants/adCampaigns';

class MonsterMeLandingPage extends Component {
  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const { fetchMediaLists, location } = this.props;
    const qs = {};
    fetchMediaLists(MONSTER_ME_MEDIA_TYPE, location.pathname, qs);
  }

  render() {
    const {
      isFetching,
      errors,
      lists,
      // monsterMeLandingHero,
      // harryMoonSeriesHero,
    } = this.props;

    if (errors.lists && !lists) {
      return (
        <ErrorPage
          errorCode="500"
          errorType="unknownError"
          errorMessage={errors.lists.message}
        />
      );
    }

    if (isFetching) {
      return <Loading />;
    }

    const bookList = lists && [lists[0]];

    return (
      <main>
        <DocumentHeadFields documentTitle="Monster Me Series" />
        <div className="Page__container Page__container--no-padding">
          <RampUnit type="leaderboard_atf" id="top" />
        </div>
        <div className="Page__ContentWrapper">
          <div className="Page__container Page__container--split-layout Page__container--main">
            <Hero
              hero={{
                id: 'MonsterMeLanding',
                title: 'Monster Me',
                link: `/books/all-phone-and-games/page/1`,
                // sponsoredBugText: ' ',
                imageURI:
                  'https://www.funbrain.com/assets/img/monster-me/Funbrain_MonsterMe_SeriesBG_06_alt.png',
                items: [],
                dek: ` Artist Writers & Artisan's iPOP! Labs presents Monster Me:
                meaningful stories and lessons packaged in a bright, fun and
                humor-filled world that kids will gravitate toward. The stories
                were created to entertain elementary school kids and educate
                them with respect to important issues from bullying and
                cyberbullying to racism and nutrition. The demand for these
                stories came directly from kids, parents, teachers and
                educators.`,
                mediaType: 'book',
                buttonLabel: 'Read now',
              }}
              // heroType="media"
              // className="GradeHeader__hero"
            />
            <section className="ContentBlock">
              <div className="ContentBlock__content">
                <div>
                  <ContentCollections lists={bookList} />
                </div>
                <div>
                  <Hero
                    hero={{
                      ...ACTIVE_AD_CAMPAIGNS.monsterMeBookHero,
                      buttons: [
                        ACTIVE_AD_CAMPAIGNS.monsterMeBookHero.buttons[0],
                      ],
                    }}
                    sponsored={false}
                    id={'PartOfMonsterMeBanner'}
                  />
                </div>
                {/*  <div>
                  <AdditionalMaterials
                    title="Monster Makers Wanted Contest"
                    description=""
                    items={PARTNERSHIPS_AND_RESOURCES}
                  />
                </div> */}
              </div>

              <aside className="ContentBlock__aside">
                <VideoSiderailPlayer />
                <RampUnit type="med_rect_atf" id="siderec" />
                <RampUnit type="med_rect_btf" id="sideflex" />
              </aside>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, { location }) => {
  return {
    isFetching: reducers.getIsPageFetching(state),
    monsterMeLandingHero: reducers.getAdCampaign(
      state,
      MONSTER_ME_LANDING_HERO
    ),
    lists: reducers.getMediaLists(
      state,
      MONSTER_ME_MEDIA_TYPE,
      location.pathname
    ),
    errors: reducers.getErrors(state),
  };
};

const MonsterMeLandingPageComponent = connect(mapStateToProps, { ...listsActions, ...adsActions })(MonsterMeLandingPage);

export default withLocationWrapper(MonsterMeLandingPageComponent);
